import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, ViewChild } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appEmailRestricter]'
})
export class EmailRestricterDirective implements OnChanges, AfterViewInit  {
  regexStr= '^[a-zA-Z0-9!#$%&*_. _]*$';
  @Input('appEmailRestricter') value: string
  @Input('changedVal') changedVal: string
  @ViewChild('input', { static: false }) input:ElementRef;

  constructor(private el:ElementRef) {
    // this.validateFields()
  }

  ngAfterViewInit() {
    // @ViewChild('input') input:ElementRef;
  }

  ngOnChanges() {
    console.log(this.changedVal);
    if(this.value == 'a') {
      (this.el.nativeElement as HTMLInputElement).value = this.changedVal.replace(/[^a-zA-Z0-9!#$%&*_. -]/g, '')
    }
  }

  // @HostListener('change', ['$event'])
  // OnLoad(event: ClipboardEvent) {
  //   if(this.value == 'a') {
  //     console.log(event);
  //     this.validateFields(event);
  //   }
  // }

  @HostListener('keypress', ['$event'])
  onKeyPress(event) {
    if(this.value == 'a') {
      return new RegExp(this.regexStr).test(event.key);
    }
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    if(this.value == 'a') {
      this.validateFields(event);
    }
  }

  validateFields(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/[^a-zA-Z0-9!#$%&*_. -]/g, '');
    document.execCommand('insertHTML', false,pasteData);
  }

}
